module.exports = __webpack_public_path__ + "static/media/facebook.b7c6ef8c.svg";